import { Box, Button, Typography } from '@mui/material'

import React from 'react'

const FranchizeBox = ({phone}) => {
  return (
    <Box  p={phone?"10px":"50px 0 "}  sx={{backgroundImage:'url(/images/franchizeback.png)'}} className='cover'>
         <Box display={"flex"} flexDirection={phone?"column" :"row"} justifyContent={"space-around"} alignItems={phone ? "center" :"flex-start"} p="10px"  gap={phone&&3}>
            <h2 style={{color:'#000',textAlign:phone&&'center'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom">اولین فرانچایز واقعی در ایران</h2>

            <h6 style={{color:"#000", width:phone?"100%":"224px",textAlign:phone &&'center'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom"> سرمایه  گذاری مطمئن و سودآور. هر آنچه برای مدیریت کسب و کار نیاز دارید در دستان شماست</h6>
            <Box component={"a"} href='tel:1507'>
            <img src="/images/tel.png"  alt="" data-aos="fade-up" data-aos-anchor-placement="top-bottom"  />

            </Box>
        </Box>

        <Box display={"flex"} justifyContent={"space-around"} alignItems={"center"}  flexDirection={phone ? "column":"row"} gap={phone?3:45} p="20px 10px">
            <Box display={"flex"} gap={2} flexDirection={phone ? "column":"row"}>
                <Button variant="outlined" sx={{borderRadius:'15px',color:'#000',border:'1px solid #000',fontWeight:'bold'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  >مجموعه مدیریتی</Button>
                <Button variant="outlined" sx={{borderRadius:'15px',color:'#000',border:'1px solid #000',fontWeight:'bold'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom"   onClick={() => window.location.href = "https://superapp.jansnak.com/franchizing"} > اخذ نمایندگی </Button>
                <Button variant="outlined" sx={{borderRadius:'15px',color:'#000',border:'1px solid #000',fontWeight:'bold'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  > فرانچایز واقعی </Button>
            </Box>
            <Box>
                <h6 style={{color:'#000',fontWeight:'bold'}}>رستوران های زنجیره ای</h6>
            </Box>
        </Box>
       <Box component={"div"} onClick={() => window.location.href = "https://superapp.jansnak.com/franchizing"} p="20px 10px" data-aos="fade-up" data-aos-anchor-placement="top-bottom"    borderRadius={"50px"} display={"flex"} justifyContent={"space-around"} alignItems={"center"} m="auto" width="95%" position={"relative"}>
           <img src="/images/franchise.png" alt="" width={phone ?"100%" :"98%"} height={"100%"} style={{margin:'auto'}}  />
            {!phone&&
                <Box  sx={{cursor:'pointer'}} flexDirection={"column"} gap={2} display={"flex"} alignItems={"flex-start"} width="80%" position={"absolute"}>
                    <h1 style={{fontSize:'100px'}}>فرانچایز</h1>
                    <Box display={"flex"} alignItems={"center"} gap={2}>
                        <h1 style={{fontSize:'40px'}}>و اخذ نمایندگی</h1>
                        <img src="/images/ArrowBack.png" alt="" width={"40px"} />

                    </Box>
                </Box>
            }
        </Box>
        {!phone&& <Box display={"flex"}   justifyContent={"space-around"} alignItems={"center"}  flexDirection={phone ? "column":"row"} gap={phone?3:45} p="20px 10px">
            <Box display={"flex"} gap={2} flexDirection={phone ? "column":"row"}>
                <Button variant="outlined" sx={{borderRadius:'15px',color:'#000',border:'1px solid #000',fontWeight:'bold'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  >مجموعه مدیریتی</Button>
                <Button variant="outlined" sx={{borderRadius:'15px',color:'#000',border:'1px solid #000',fontWeight:'bold'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom"   onClick={() => window.location.href = "https://superapp.jansnak.com/franchizing"}> اخذ نمایندگی </Button>
                <Button variant="outlined" sx={{borderRadius:'15px',color:'#000',border:'1px solid #000',fontWeight:'bold'}} data-aos="fade-up" data-aos-anchor-placement="top-bottom"  > فرانچایز واقعی </Button>
            </Box>
            <Box>
                <h6 style={{color:'#000',fontWeight:'bold'}}>رستوران های زنجیره ای</h6>
            </Box>
        </Box>}
        <Box display={"flex"}  justifyContent={"center"} alignItems={"center"}   data-aos="fade-up" data-aos-anchor-placement="top-bottom"  >
            <Box component={"div"} position={"relative"} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}  onClick={() => window.location.href = "https://superapp.jansnak.com/franchizing"}>
              <img src="/images/color.png" alt=""width={phone ?"100%" :"98%"} height={phone?'100px':'100%'} style={{padding:'10px',margin:"auto"}}  />
            </Box>
        </Box>  
    </Box>

  )
}

export default FranchizeBox